// inv/src/pages/authentication/Account.jsx
import { useState } from 'react';
import { useAuth } from '../../components/authentication/AuthContext';
import GeneralSettings from './GeneralSettings';
import Billing from './Billing';

const AccountPage = () => {
  const { user, loading } = useAuth();
  const [activeTab, setActiveTab] = useState('general');
  const [copySuccess, setCopySuccess] = useState(false);

  const copyUserId = () => {
    if (!user?.user_id) return;
    navigator.clipboard.writeText(user.user_id)
      .then(() => {
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      })
      .catch((err) => {
        console.error('Не удалось скопировать!', err);
      });
  };

  if (loading) {
    return (
      <main className="p-6">
        <h1 className="text-2xl font-semibold">My Account</h1>
        <p>Loading account data…</p>
      </main>
    );
  }

  return (
    <div className="container mx-auto my-8">
      <div className="flex flex-col md:flex-row items-stretch">
        <aside className="w-full md:w-1/4 lg:w-1/5 bg-white shadow-md rounded-lg">
          <div className="p-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-6">Settings</h2>
            <ul className="menu rounded-box w-56">
              <li>
                <button
                  onClick={() => setActiveTab('general')}
                  className={`flex items-center cursor-pointer my-2 p-2 text-stone-700 rounded hover:bg-stone-200 w-full text-left ${activeTab === 'general' ? 'bg-stone-200' : ''
                    }`}
                >
                  General settings
                </button>
              </li>
              <li>
                <button
                  onClick={() => setActiveTab('billing')}
                  className={`flex items-center cursor-pointer p-2 text-stone-700 rounded hover:bg-stone-200 w-full text-left ${activeTab === 'billing' ? 'bg-stone-200' : ''
                    }`}
                >
                  Billing
                </button>
              </li>
            </ul>
            <div className="mt-6">
              <p className="text-gray-600 text-sm">
                My user ID:{' '}
                <button
                  onClick={copyUserId}
                  className="cursor-pointer ml-4 btn btn-xs"
                >
                  {copySuccess ? 'Copied!' : 'Copy User ID'}
                </button>
              </p>
            </div>
          </div>
        </aside>

        <main className="flex-1 ml-0 md:ml-6 mt-6 md:mt-0 flex flex-col gap-6">
          {activeTab === 'general' && (
            <div className="rounded-lg p-6 h-full">
              <GeneralSettings />
            </div>
          )}
          {activeTab === 'billing' && (
            <div className="rounded-lg p-6 h-full">
              <Billing user={user} />
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default AccountPage;
